import React from 'react';
import { Field } from 'formik';
import TextField from 'modules/af_cm_ui_kit/components/TextField/TextField';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_LABELS, RADIO_VALUES } from '../types';
import { FirmAdminProps } from './types';
import ChangeableTextField from 'shared/Profile/ChangeableTextField';
import ChangeableAddress from 'shared/Profile/ChangeableAddress';

import styles from '../profile.module.scss';

const FirmAdmin: React.FC<FirmAdminProps> = ({ index, isClub, onChangeClick, addressValues, setFieldValue }) => {
  const createFieldName = (fieldName: string) => `${FIELDS.ADMINS}.${index}.${fieldName}`;

  const lmcChangeHandler = (event: any) => {
    const lmcHandler = onChangeClick('lmc_is_active');
    lmcHandler(event.target.value === 'active');
  };

  return (
    <>
      <Field
        component={TextField}
        name={createFieldName(FIELDS.ADMIN_NAME)}
        title={FIELDS_LABELS.ADMIN_NAME}
        disabled={true}
      />

      {!isClub && (
        <Field
          component={TextField}
          name={createFieldName(FIELDS.ADMIN_FCA)}
          title={FIELDS_LABELS.ADMIN_FCA}
          disabled={true}
        />
      )}

      <ChangeableAddress
        onChangeClick={onChangeClick}
        addressValues={addressValues}
        setFieldValue={setFieldValue}
        prefix={`${FIELDS.ADMINS}.${index}`}
      />

      <Field
        component={ChangeableTextField}
        name={createFieldName(FIELDS.ADMIN_EMAIL)}
        title={FIELDS_LABELS.ADMIN_EMAIL}
        onChangeClick={onChangeClick(FIELDS.ADMIN_EMAIL)}
      />

      <Field
        component={ChangeableTextField}
        variant={VARIANTS_TYPES.PHONE}
        name={createFieldName(FIELDS.ADMIN_PHONE)}
        title={FIELDS_LABELS.ADMIN_PHONE}
        onChangeClick={onChangeClick(FIELDS.ADMIN_PHONE)}
      />

      {!isClub && (
        <>
          <label className={`${styles.label} ${styles.adminFcaLabel}`}>{FIELDS_LABELS.ADMIN_LMC_STATUS}</label>
          <div
            className={styles.radioContainer}
            role="group"
            aria-labelledby={FIELDS_LABELS.ADMIN_LMC_STATUS}
            onChange={lmcChangeHandler}>
            <label>
              <Field
                type="radio"
                name={createFieldName(FIELDS.ADMIN_LMC_STATUS)}
                value={RADIO_VALUES.ACTIVE}
                className={styles.radioBtn}
              />
              <span className={styles.customRadio} />
              Active
            </label>
            <label>
              <Field
                type="radio"
                name={createFieldName(FIELDS.ADMIN_LMC_STATUS)}
                value={RADIO_VALUES.INACTIVE}
                className={styles.radioBtn}
              />
              <span className={styles.customRadio} />
              Inactive
            </label>
          </div>
        </>
      )}
    </>
  );
};

export default FirmAdmin;
